module.exports = __webpack_public_path__ + "static/img/14000505.7b6b279a.png";